export type IChangeUrlParamOnClick = (e: JQuery.ClickEvent<HTMLElement>) => void;

export function changeUrlParamOnClick(e: JQuery.ClickEvent<HTMLElement>) {
  const $button = $(e.currentTarget);
  const param = $button.data('param');
  const value = $button.data('value');
  const url = window.location.href;
  const hasParamInUrl = window.DexeroCoreApp.getUrlParamValue(param, url);
  if (hasParamInUrl) {
    const newUrl = window.DexeroCoreApp.modifyUrlParam(url, param, value);
    window.DexeroCoreApp.redirectToPage(newUrl);
  } else {
    window.DexeroCoreApp.redirectToPage(
      `${url}${window.DexeroCoreApp.getUrlSeperator(url)}${param}=${value}`
    );
  }
}
